export type SchemeKey = "CPS" | "PPP";

export const SCHEME_FULL_NAME: Record<SchemeKey, string> = {
  CPS: "Contribution Pension Scheme",
  PPP: "Personal Pension Plan",
};

export type ParsedCpsPpp =
  | { ok: true; rows: { key: SchemeKey; amount: string }[] }
  | { ok: false; raw: string };

/**
 * Parse API string: CPS\n<amount>\nPPP\n<amount> (line order may vary; labels must be CPS/PPP).
 */
export function parseCpsPppValue(text: string | undefined | null): ParsedCpsPpp {
  if (text == null || !String(text).trim()) {
    return { ok: false, raw: text ?? "" };
  }

  const lines = String(text)
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter((l) => l.length > 0);

  if (lines.length < 2) {
    return { ok: false, raw: String(text) };
  }

  let cps: string | undefined;
  let ppp: string | undefined;

  for (let i = 0; i < lines.length; i++) {
    if (lines[i] === "CPS" && i + 1 < lines.length) {
      cps = lines[i + 1];
    }
    if (lines[i] === "PPP" && i + 1 < lines.length) {
      ppp = lines[i + 1];
    }
  }

  if (cps != null && ppp != null) {
    return {
      ok: true,
      rows: [
        { key: "CPS" as const, amount: cps },
        { key: "PPP" as const, amount: ppp },
      ],
    };
  }

  return { ok: false, raw: String(text) };
}

export function maskParsedAmounts(
  rows: { key: SchemeKey; amount: string }[]
): { key: SchemeKey; amount: string }[] {
  return rows.map((r) => ({ ...r, amount: "***" }));
}

export function maskRawCpsPppText(text: string): string {
  if (!text) {
    return text;
  }
  return text
    .split(/\r?\n/)
    .map((line) => {
      const t = line.trim();
      if (t === "CPS" || t === "PPP") {
        return t;
      }
      return "***";
    })
    .join("\n");
}
